import { DATA_SOURCE } from "../../../util/Data/DataModeling";

// lookup for Namespace in locales based on screen for which help should load
export const localesLookup = {
  Workspace: "workspace",
  "Data Connections": "data-connections",
  "Data Exchange Job": "data-exchange-job",
  "SQL Explorer": "data-explorer",
  "Quick Import": "quick-import",
  [DATA_SOURCE.plural]: "datasets",
  Entities: "entities",
  [`Add ${DATA_SOURCE.singular}`]: "add-dataset",
  "Add Entity": "add-entity",
  "Data Pipelines": "data-pipelines",
  "Apply to Data Warehouse": "apply-to-data-warehouse",
  "Data Load Job": "data-load-job",
  "Data Quality Job": "data-quality-job",
  "Data Mastering Job": "data-mastering-job",
  "Data Deduplication Job": "data-deduplication-job",
  "Data Transform Job": "data-transform-job",
  "Notebook Job": "notebook-job",
  "Manage Schemas": "manage-schema",
  "Import Workspace": "import-workspace",
  "Export Workspace": "export-workspace",
  "DQM Dashboard": "data-quality-dashboard",
  "Data Pipeline Canvas": "data-pipeline-canvas",
  "Dataset Statistics": "dataset-statistics",
  "Entity Statistics": "entity-statistics",
  "SageMaker Usage": "sagemaker-usage",
  "Snowflake Usage": "snowflake-usage",
  "Manage Workspaces": "manage-workspaces",
  "User Managment": "user-management",
  "Audit Report": "audit-history",
  "Steward Cases": "cases",
  "Job Engine Usage": "job-engine",
  "Data AI Usage": "data-ai",
  "Workspace Access": "workspace-access",
};
